<template>
  <div class="order-add-ons">
    <add-ons-header></add-ons-header>
    <b-container class="order-add-ons__body">
      <!-- COVID-19 / CTH-1658 Add On Limits messaging -->
      <limited-addons-alert />

      <error-container v-bind:type="'general'"></error-container>
      <div class="order-add-ons__review">
        <div class="cart-heading mb-md-4">
          <h1 class="cart-h1">Review Add-Ons</h1>
        </div>

        <template v-if="showSubstitutionsToggle">
          <b-tooltip
            target="tooltip-substitutions"
            triggers="hover focus click blur"
            container="curbsideCheckout">
            Our goal is never to be out of stock on any item. However, if an
            item is out of stock we will make every effort to contact you and
            substitute with an item as close to the price and size of the
            original item.
          </b-tooltip>

          <div class="add-ons-substitutions">
            <input id="subs-preference-all"
              class="add-ons-substitutions__checkbox"
              type="checkbox"
              v-model="addOnSubstitutions"
              @change="toggleOrderSubstitutions()"
            />
            <label for="subs-preference-all" class="add-ons-substitutions__label">
              Allow substitutions
            </label>
            <span tabindex="0" id="tooltip-substitutions"
              ><span class="fa fa-question-circle"></span
            ></span>
          </div>
        </template>

        <div v-if="orderAddOnsDetails.commerceItems.length > 0" class="mb-3">
          <h6 class="products-list-group__header">
            Added
          </h6>
          <div class="products-list-group add-ons-products bg-white pl-3 pr-3">
            <div
              v-for="(item, index) in orderAddOnsDetails.commerceItems"
              :key="index"
              class="add-ons-product-item"
            >
              <cart-item
                :cartItem="item"
                :categoryIndex="1"
                :itemIndex="index"
                listname="Requested Add-Ons"
                :position="index + 1"
                productLinkDestination="modal"
                :showCoupons="false"
                :overrideAddToBucket="preventAddToBucket"
                bucket="orderAddOns"
              ></cart-item>
            </div>
          </div>
        </div>

        <div v-if="orderHistoryDetails.orderItems">
          <h6 class="products-list-group__header">
            Your order
          </h6>
          <div class="products-list-group add-ons-products bg-white p-2">
            <div
              v-for="(item, index) in orderHistoryDetails.orderItems"
              :key="index"
              class="add-ons-product-item p-2"
            >
              <cart-item-history
                :cartItem="item"
                :categoryIndex="1"
                :itemIndex="index"
                listname="Current Order"
                :position="index + 1"
                bucket="orderAddOns"
              ></cart-item-history>
            </div>
          </div>
        </div>
      </div>
    </b-container>
    <add-ons-footer></add-ons-footer>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import OrderAddOnsHeader from "./OrderAddOnsHeader";
import OrderAddOnsFooter from "./OrderAddOnsFooter";
import Errors from "./Errors";
import CartItem from "./cart/CartItem";
import CartItemHistory from "./cart/CartItemHistory";
import LimitedAddonsAlert from './LimitedAddonsAlert';

export default {
  name: "OrderAddOnsReview",
  components: {
    "add-ons-header": OrderAddOnsHeader,
    "add-ons-footer": OrderAddOnsFooter,
    "error-container": Errors,
    "cart-item": CartItem,
    "cart-item-history": CartItemHistory,
    "limited-addons-alert": LimitedAddonsAlert
  },
  created() {
    this.$store.dispatch("orderAddOns/GET_ADD_ONS", this.$route.params.orderId);
    this.$store.dispatch(
      "orderHistory/GET_ORDER_DETAILS",
      this.$route.params.orderId
    );
  },
  computed: {
    orderHistoryDetails() {
      return this.$store.state.orderHistory.singleOrder;
    },
    orderAddOnsDetails() {
      return this.$store.state.orderAddOns.orderAddOn;
    },
    preventAddToBucket() {
      return this.orderAddOnsDetails.remainingAddOnItems === 0;
    },
    showSubstitutionsToggle() {
      return this.addOnSubstitutionsEnabled &&
        this.orderAddOnsDetails.commerceItems.some(item => item.substitutionPreferenceEnabled);
    },
    ...mapGetters({
      addOnSubstitutions: 'orderAddOns/addOnSubstitutions',
      addOnSubstitutionsEnabled: 'orderAddOns/addOnSubstitutionsEnabled',
    })
  },
  methods: {
    toggleOrderSubstitutions() {
      this.$store.commit("orderAddOns/TOGGLE_ORDER_SUBSTITUTIONS");
    }
  },
  watch: {
    addOnSubstitutionsEnabled: function(value) {
      if (value === false) {
        this.$store.dispatch("orderAddOns/PUT_ORDER_SUBSTITUTION", false);
      }
    }
  }
};
</script>

<style lang="scss">
// This component is standalone, and therefore needs curbside styles
@import "../styles";
</style>

<style lang="scss" scoped>
@import "../assets/lib";

.cart-heading {
 padding-left: 0;
}

.add-ons-products {
  box-shadow: 0 0 4px rgba(#000, 0.1);
}

.add-ons-product-item + .add-ons-product-item {
  border-top: 1px solid $color-divider-light-gray;
}

.add-ons-product-item__price {
  font-size: 1.125rem;
}

.add-ons-substitutions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 8px;
  margin-top: 24px;
  font-weight: 600;

  .fa-question-circle {
    color: #adadad;
    margin-left: 8px;
  }
}

.add-ons-substitutions__label {
  display: flex;
  align-items: center;
  margin-bottom: 0 !important;
}

.add-ons-substitutions__checkbox {
  margin-right: 8px;
}

.products-list-group {
  margin-bottom: 32px;
}

.products-list-group__header {
  font-size: 19px;
  font-weight: 800;
  margin: 0 0 16px;
}

.product-list-group__item-note {
  font-size: 0.75rem;
}

// Account for sticky header and footer
@media screen and (min-width: $breakpoint-desktop) {
  .order-add-ons__body {
    padding-top: 7rem;
  }
}

.cart {
  padding-bottom: 136px;
}

.cart-actions {
  font-weight: 600;
  font-size: 14px;
}

.reservation-display {
  margin-bottom: 32px;
}

.panel {
  background: #fff;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.15);
  padding: 16px;
  margin-bottom: 8px;
}

.cart-empty-message {
  text-align: center;
  padding: 64px;
}

.cart-contents {
  a {
    color: $color-text-standard;
  }

  a:hover {
    text-decoration: underline;
  }
}

.covid-warning-container {
  border: 2px solid orange;
  display: flex;
  align-items: center;
  justify-content: left;
}

.covid-warning-container .fa-warning {
  color: orange;
  margin-right: 15px;
}
</style>
